import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import Modal, { IModalChildProps } from '../common/modal';

const DataAuthorizationModal = ({ onAccept, onClose }: IModalChildProps) => {
    const [acceptState, setAcceptState] = useState(false);

    useEffect(() => {
        return () => {
            setAcceptState(false);
        };
    }, []);

    const handleChange = (event: any) => {
        const { value } = event.target;

        setAcceptState(value);
    };

    return (
        <Modal>
            <>
                <div className="modal-header">
                    <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                        onClick={onClose}
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <h4 className="modal-title">
                        <FormattedMessage id="Data_Authorization_Agreement" />
                    </h4>
                </div>
                <div className="modal-body">
                    <p>
                        <FormattedMessage id="Data_Authorization_Agreement_Part_1" />
                    </p>
                    <p
                        style={{
                            textDecoration: 'underline',
                            textTransform: 'uppercase',
                        }}
                    >
                        <FormattedMessage id="Data_Authorization_Agreement_Part_2" />
                    </p>
                    <p>
                        <FormattedMessage
                            id="Data_Authorization_Agreement_Part_3"
                            values={{
                                0: (
                                    <a href="mailto:contabilidad@starkey.com">
                                        contabilidad@starkey.com
                                    </a>
                                ),
                                1: 'Cra 13 No. 94a 25 Of. 504',
                            }}
                        />
                    </p>
                    <div className="form-inline">
                        <div className="checkbox">
                            <label>
                                <input
                                    type="checkbox"
                                    checked={acceptState}
                                    onChange={handleChange}
                                />
                                &nbsp;
                                <span>
                                    <FormattedMessage id="Data_Authorization_Agreement_Part_4" />
                                </span>
                            </label>
                        </div>
                    </div>
                </div>
                <div className="modal-footer">
                    <div className="form-inline">
                        <div className="form-group">
                            <button
                                className="btn btn-primary"
                                onClick={onAccept}
                                disabled={!acceptState}
                            >
                                <FormattedMessage id="Save" />
                            </button>
                        </div>
                        &nbsp;
                        <div className="form-group">
                            <button
                                className="btn btn-default"
                                onClick={onClose}
                            >
                                <FormattedMessage id="Cancel" />
                            </button>
                        </div>
                    </div>
                </div>
            </>
        </Modal>
    );
};

export default DataAuthorizationModal;
